import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import Card from '../components/common/Card';
import PageHero from '../components/layout/PageHero';
import { careerPages } from '../data/pageContent';

function CareerPage({ pageKey }) {
  const { careerSlug } = useParams();
  const [searchParams] = useSearchParams();
  const page = careerPages[pageKey || careerSlug];
  const selectedJob = searchParams.get('job');

  if (!page) {
    return <Navigate replace to="/jobs" />;
  }

  return (
    <>
      <PageHero eyebrow={page.label} title={page.title} description={page.description} />
      <section className="section page-content">
        <div className="container">
          <Card>
            {pageKey === 'apply' ? (
              <>
                <h2>Share your profile</h2>
                <p>
                  The full application workflow will be added soon. For now, please contact
                  FactorStreet and mention the role you are applying for.
                </p>
                {selectedJob ? <p>Selected role: {selectedJob}</p> : null}
              </>
            ) : (
              <>
                <h2>Content will be added soon</h2>
                <p>
                  FactorStreet will use this page for future hiring updates, applications, and team
                  expansion details.
                </p>
              </>
            )}
          </Card>
        </div>
      </section>
    </>
  );
}

export default CareerPage;
